import axios from "axios";

const searchQueryAPI = async (query: string) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/search/query`,
    {
      query: query,
    }
  );
  return response.data;
};

export default searchQueryAPI;
